module.exports = __webpack_public_path__ + "static/media/tooltip-arrow-right.073970f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip-arrow-right.svg
// module id = 1086
// module chunks = 0